import { useContext } from 'react'
import { PaymentContext } from 'App'

export const usePaymentContext = () => {
  return useContext(PaymentContext)
}
